function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Lightning = function Lightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    d: "M9.679 24a1.9 1.9 0 0 1-.835-.198 1.88 1.88 0 0 1-1.04-2.107l1.687-7.468H6.866a1.87 1.87 0 0 1-1.678-1.063 1.89 1.89 0 0 1 .178-1.937L13.138.756a1.875 1.875 0 0 1 2.25-.602 1.88 1.88 0 0 1 1.097 2.07l-1.35 7.299h2.982a1.87 1.87 0 0 1 1.696 1.063 1.89 1.89 0 0 1-.224 1.994l-8.494 10.704A1.88 1.88 0 0 1 9.679 24M9.49 12.346a1.87 1.87 0 0 1 1.501.69 1.88 1.88 0 0 1 .374 1.614L9.68 22.11l8.438-10.705h-2.982a1.87 1.87 0 0 1-1.46-.664 1.89 1.89 0 0 1-.415-1.556l1.378-7.308-7.772 10.469z"
  }));
};
export default Lightning;